"use client";

import Link from "next/link";
import { useEffect, useRef, useState } from "react";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";

interface IDropdownProps {
  label: string;
  items: { href: string; label: string }[];
  isMobile?: boolean;
  onClick: () => void
  active?: boolean;
}

export const Dropdown = ({
  label,
  items,
  isMobile = false,
  onClick = () => { },
  active = false
}: IDropdownProps) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  const toggleDropdown = () => setIsOpen(!isOpen);
  const closeDropdown = () => setIsOpen(false);
  const handleLink = () => {
    onClick()
    setIsOpen(false);
  }

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (!dropdownRef.current?.contains(event.target as Node)) {
        closeDropdown();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div
      ref={dropdownRef}
      className={`relative ${isMobile ? "w-full" : "group"}`}
    >
      <button
        aria-haspopup="true"
        aria-expanded={isOpen}
        className={`flex items-center ${isMobile ? "justify-between w-full text-lg" : "text-black-600"
          } text-black-600 hover:text-primary transition-colors whitespace-nowrap ${active ? "text-primary" : ""}`}
        onClick={toggleDropdown}
      >
        {label}
        <span className="ml-2">
          {isOpen ? (
            <FaChevronUp className="text-sm" aria-hidden="true" />
          ) : (
            <FaChevronDown className="text-sm" aria-hidden="true" />
          )}
        </span>
      </button>
      <div
        className={`flex flex-col gap-2 overflow-hidden transition-[max-height] duration-300 ease-in-out rounded-md shadow-none md:shadow
          ${isOpen ? "max-h-96 opacity-100" : "max-h-0 opacity-0"} 
          ${isMobile ? "pl-4 space-y-2" : "absolute left-0 top-full bg-white p-4 w-52"}
          ${isOpen && isMobile && "my-4"}
        `}
        style={{ opacity: isOpen ? 1 : 0 }}
        role="menu"
      >
        {items.map((item, index) => (
          <Link
            key={index}
            href={item.href}
            className={`block text-black-600 hover:text-primary transition-colors`}
            onClick={handleLink}
            role="menuitem"
          >
            {item.label}
          </Link>
        ))}
      </div>
    </div>
  );
};
